export default "images/L3.jpg";